import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51324dfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tyres_patterns" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sub_title" }, "From racetrack to road", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "TYRE PATTERNS", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fw_500" }, " Whether you drive a passenger car, CUV, SUV or Light Truck, we have the exact tyre to suit your needs. Falken’s tyres are time-tested on the street, racetrack and off-road, and come up first every time, every day. Go with capability and the strength of experience when selecting your new set of tyres. It’s time for Falken. ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom_border" }, null, -1))

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createVNode(_component_router_link, {
                to: { path: '/tyre-range' , hash: '#tyreRange'},
                class: "btn blue_btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("VIEW OUR PATTERNS")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _hoisted_9
  ], 64))
}